/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
  theme.manuallyLoadImages(this);
  this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());

  const rewardText = this.querySelector('.lmior-cart-reward__text');
  const rewardProgress = this.querySelector('.lmior-cart-reward__progress');
  const cartCount = this.querySelector('.cart-drawer__title-count');

  if (rewardText && rewardProgress && cartCount) {
    const count = parseInt(cartCount.textContent.replace(/\D/g, ''), 10) || 0;

    if (count >= 2) {
      rewardText.innerHTML = '<strong>Du har låst upp 200 kr rabatt + gåva</strong>';
      rewardProgress.style.width = '100%';
    } else {
      rewardText.innerHTML = 'Lägg till en vara till och få <strong>200 kr rabatt + gåva</strong>';
      rewardProgress.style.width = '50%';
    }
  }
});
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
